<template>
  <div class="stats-info" v-if="matchIndexes">
    <template v-for="(type) in ['signals', 'parts']">
      <div style="display: flex; width: 100%; align-items: center; justify-content: center;"
        v-for="(value, key, index) in matchIndexes[type]" :key="index + key">
        <div class="stats">
          <div class="item" :class='{ active: value > 0 }'>
            <span>{{ key }} [{{ value }}]</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "StatsInfo",
  props: {
    matchIndexes: {
      type: Object,
      require: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.stats-info {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  width: max-content;

  .stats {
    display: flex;
    align-items: center;
    gap: 7px;

    .item {
      display: flex;
      justify-content: center;
      align-items: center;
      flex: none;
      white-space: nowrap;
      padding: 3px 6px 3px 6px;
      width: 40px;
      height: 18px;
      border-radius: 10px;
      border: 1px solid var(--font-color);

      span {
        font-weight: 400;
        font-size: 10px;
        line-height: 12.4px;
        letter-spacing: 0.02em;
        color: var(--font-color);
        text-align: center;
      }
    }

    .active {
      background-color: var(--success-color);
      border: 1px solid var(--success-color);

      span {
        color: #FFFFFF;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .stats-info {
    margin-bottom: 10px;
  }
}
</style>